import React, { useCallback, useState } from 'react';
import { useRecoilValue } from 'recoil';
import PropTypes from 'prop-types';

import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { FlexBox } from '@ecp/common/src/layouts/flex/styled';
import { TextBox } from '@ecp/common/src/text/TextBox';
import Button from '@ecp/common/src/components/button/bo/Button';

import { isManagerValue } from '@bo-recoil/common/user/atom';
import FormAccordion from '@bo-components/common/form/FormAccordion';
import Grid from '@bo-components/common/grid/Grid';
import { ReactComponent as Refresh } from '@bo-assets/icon/common/icon__form-refresh.svg';

const gridOptions = {
  LeftCols: [],
  Cols: [
    {
      Header: '약관유형',
      Type: 'Text',
      Name: 'termsTypeName',
      MinWidth: 150,
      Width: 150,
    },
    {
      Header: '약관명',
      Type: 'Text',
      Name: 'termsName',
      MinWidth: 150,
      RelWidth: 1,
    },
    {
      Header: '시작일',
      Type: 'Date',
      Name: 'applyStartDateTime',
      MinWidth: 150,
      Width: 150,
      DataFormat: 'yyyyMMddHHmmss',
      Format: 'yyyy-mm-dd',
    },
  ],
};

const DetailTermInfo = ({ siteTermList, refreshTerm }) => {
  const [gridData, setGridData] = useState(siteTermList);
  const isManager = useRecoilValue(isManagerValue) && !location.pathname.includes('minor');
  const handleTermClick = () => {
    window.open('/system/terms-management');
  };

  const handleFirstRender = useCallback(() => {
    setGridData(siteTermList);
  }, [siteTermList, setGridData]);

  const Buttons = () => (
    <>
      <Button width={'fit-content'} onClick={refreshTerm}>
        <Refresh />
      </Button>
      {isManager && (
        <>
          <Spacing left={6} />
          <Button move onClick={handleTermClick} type={'Third'}>
            약관관리
          </Button>
        </>
      )}
    </>
  );

  return (
    <FormAccordion label={'약관관리'} initialOpen buttonless noFold customControl={Buttons()}>
      {siteTermList.length > 0 ? (
        <Grid
          unPaged
          readOnly
          height={'200px'}
          data={gridData}
          onRenderFirstFinish={handleFirstRender}
          options={gridOptions}
        />
      ) : (
        <FlexBox height={'271px'} width={'100%'} align-items={'center'} justify-content={'center'}>
          <TextBox>등록된 약관이 없습니다</TextBox>
        </FlexBox>
      )}
    </FormAccordion>
  );
};

export default DetailTermInfo;

DetailTermInfo.propTypes = {
  siteTermList: PropTypes.arrayOf(PropTypes.object),
  refreshTerm: PropTypes.func,
};
